/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-southeast-1",
    "aws_dynamodb_all_tables_region": "ap-southeast-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "PollOptionTable-prod",
            "region": "ap-southeast-1"
        },
        {
            "tableName": "PollTable2-prod",
            "region": "ap-southeast-1"
        },
        {
            "tableName": "PollOptionTable2-prod",
            "region": "ap-southeast-1"
        },
        {
            "tableName": "JoyworldVoucher-prod",
            "region": "ap-southeast-1"
        },
        {
            "tableName": "JoyworldQRQuest-prod",
            "region": "ap-southeast-1"
        },
        {
            "tableName": "DisruptionPoll-prod",
            "region": "ap-southeast-1"
        }
    ],
    "aws_user_files_s3_bucket": "joyworld-admin-voucher-image154039-prod",
    "aws_user_files_s3_bucket_region": "ap-southeast-1",
    "aws_cognito_identity_pool_id": "ap-southeast-1:5715efd1-917b-4035-9768-a9a875e839af",
    "aws_cognito_region": "ap-southeast-1",
    "aws_user_pools_id": "ap-southeast-1_oUdBGrDSH",
    "aws_user_pools_web_client_id": "urr6nouvdaqii082de049cvjk",
    "oauth": {},
    "aws_cloud_logic_custom": [
        {
            "name": "PollingApi2",
            "endpoint": "https://4fk299drqb.execute-api.ap-southeast-1.amazonaws.com/prod",
            "region": "ap-southeast-1"
        },
        {
            "name": "JoyworldVoucher",
            "endpoint": "https://wmhxxsh1o1.execute-api.ap-southeast-1.amazonaws.com/prod",
            "region": "ap-southeast-1"
        },
        {
            "name": "JoyworldQRApi",
            "endpoint": "https://ykds2oq5w3.execute-api.ap-southeast-1.amazonaws.com/prod",
            "region": "ap-southeast-1"
        }
    ]
};


export default awsmobile;
